import apiClient, { getStorage, STORAGE_KEYS } from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';

// 本地備用圖片，依 reward_id 對應
const LOCAL_MASCOT_IMAGES = {
  1: '/image/mascot/NEW_goldbaby.png',
  5: '/image/mascot/NEW_Elephant.png',
  9: '/image/mascot/NEW_Lion.png',
  13: '/image/mascot/NEW_Deer.png',
};

export const getMascotList = async () => {
  const viewerToken = getStorage(STORAGE_KEYS.VIEWER_TOKEN);
  const response = await apiClient.post(
    ENDPOINTS.POINT_EX.ITEMS_LIST,
    { free_for_new_user: true },
    { headers: { 'X-Auth-Token': viewerToken } }
  );
  return response.items.map((item) => ({
    reward_id: item.reward_id,
    name: item.reward_name?.split('_')[0],
    image: item.reward_media || LOCAL_MASCOT_IMAGES[item.reward_id] || null,
  }));
};
